module.exports = "https://static.wmbcdn.com/uniweb/images/276c7e88ea953026d00021669fee1087.png";